import { Component, inject } from '@angular/core';
import { AssemblyComponent } from '../assembly/assembly.component';
import {
  FsExcelExportType,
  ShownPeriodsData,
} from '../../utils/common/utilityClasses';
import { PlExcelExportData } from '../../../excel/templates/financial-statement/profit-and-loss/profitAndLossTemplate';
import { PlService } from '../../services/pl/pl.service';
import { AssemblyService } from '../../services/assembly/assembly.service';
import { FsSelectorPeriod } from '../../utils/common/FsSelectorPeriod';
import { FsSums } from '../../utils/common/FsSums';
import { FsCalculationsService } from '../../services/common/fs-calculations.service';

@Component({
  selector: 'app-pl-page',
  templateUrl: './pl-page.component.html',
  styleUrls: ['../assembly/assembly.component.scss'],
  providers: [PlService, AssemblyService],
})
export class PlPageComponent extends AssemblyComponent {
  plPartSumsForCharts: FsSums[];
  periodsData: ShownPeriodsData;
  plTabs = PL_TABS;
  selectedPLTabIndex = 1;
  selectedPLTab: typeof PL_TABS[number] = PL_TABS[this.selectedPLTabIndex];

  /**
   * Instance of BsService obtained directly through Angular inject function.
   *
   * This approach streamlines dependency injection and prevents constructor overcrowding
   * in scenarios where a class inherits from a parent with multiple dependencies.
   */
  readonly plService: PlService = inject(PlService);
  protected override onInitSubscribe(financialStatementPeriod: FsSelectorPeriod): void {
    super.onInitSubscribe(financialStatementPeriod);
    this.initPL(financialStatementPeriod?.period);
  }

  protected override onChange(): void {
    this.parts = this.financialStatement.profitLossParts;
    this.plPartSumsForCharts = this.financialStatement.profitLossParts.map((part) => part.sums);
    this.initPL(this.financialStatement.period);
    this.checkEmptyState();
  }

  exportExcelPl(): void {
    this.fsExcelService.exportExcel(FsExcelExportType.PL, this.exportProfitAndLossExcelData());
  }

  override calculateTotalsAndSums(): void {
    FsCalculationsService.calculateBalanceSheetTotals(
      this.financialStatement.profitLossNetTotals,
      this.parts,
      true,
    );
  }

  private exportProfitAndLossExcelData(): PlExcelExportData {
    return {
      shownPeriodsData: this.periodsData,
      parts: this.financialStatement.profitLossParts,
      selectedPeriod: this.financialStatement.period,
      periodType: this.selectedPLTab,
    };
  }

  private initPL(financialStatementPeriod: Date): void {
    this.periodsData = this.plService.initPlDateColumns(financialStatementPeriod, this.financialStatement.profitLossParts);
  }

  private checkEmptyState(): void {
    this.show.emptyState = !this.financialStatement.profitLossNetTotals.quarterlySums.size;
  }
}
export const PL_TABS = ['Quarter over quarter', 'Year over year'] as const;
